export default "__VITE_PUBLIC_ASSET__8dbf3bc6__"